import React from "react";
import { Spin } from "antd";
import { BsFillFilePdfFill } from "react-icons/bs";

const CustomButton = ({ onClick, loading, label, disabled }) => {
  return (
    <button
      disabled={loading || disabled} // Ensure disabled prop is respected
      onClick={onClick}
      className="px-8 py-2 bg-[#03336E] rounded-lg text-[#fff] text-sm flex items-center gap-1 hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? "Loading..." : label}
      {loading ? <Spin /> : null}
    </button>
  );
};

export default CustomButton;